import React from "react";

import { DashboardPageBody } from "../../components/Page";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import PlansPage from "./ui";

const Plans = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DashboardPageBody>
        <PlansPage />
      </DashboardPageBody>
    </DashboardLayout>
  );
};

export default Plans;

